// extracted by mini-css-extract-plugin
export default {"title":"login_title_Pu6OS"};